export default __webpack_public_path__ + "static/media/logout.dfdf9433.svg";